// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-body {
  margin-left: 5rem !important;
  transition: 850ms;
  margin-top: 3rem;
  position: relative;
  min-height: 92vh;
}
.main-body .table-section {
  border: solid 1px var(--border-color);
}
.main-body .table-section .rdt_TableHeadRow {
  background-color: rgb(244, 252, 255);
  min-height: 45px;
}
.main-body .table-section .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable div {
  font-size: var(--font-size-md);
  font-weight: 600;
}
.main-body .table-section .rdt_TableBody .rdt_TableRow {
  min-height: 42px;
}
.main-body .table-section .rdt_TableBody .rdt_TableRow .rdt_TableCell div {
  font-size: var(--font-size-md);
}
.main-body .modal > div:nth-child(1) {
  box-shadow: inset 0px 3px 0px 0px var(--color-maersk-blue);
}
.main-body .modal > div:nth-child(1) > div:nth-child(2) {
  height: 50px;
  padding: 0px 24px;
  background-color: rgb(244, 252, 255);
}
.main-body .modal .modal-headerSection {
  padding: 0px 0px 8px;
  border-bottom: solid 1px var(--border-color);
  margin-bottom: 10px;
}

.Stechactive {
  margin-left: 16.5rem !important;
  transition: 350ms;
}

.button .icon:hover {
  background: transparent;
}
.button span:hover {
  background: transparent;
}

.header-text {
  font-family: Maersk Headline, sans-serif;
  font-size: 36px;
  font-weight: 300;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: left;
}

.sub-header-text {
  font-family: Maersk Headline, sans-serif;
  font-size: var(--font-size-lg);
  font-weight: 700;
  line-height: 24px;
  text-align: left;
}

.step-Indicator {
  padding: 15px 5rem 10px;
}
.step-Indicator .stepIndicator ol {
  justify-content: center;
}
.step-Indicator .stepIndicator ol li {
  max-width: 20rem;
}
.step-Indicator .stepIndicator ol li:last-child {
  flex-grow: 0;
}

.details-section .details-box {
  border: var(--border-color) solid 1px;
  text-align: center;
  font-size: var(--font-size-md);
  background: var(--color-white);
  font-weight: 500;
}
.details-section .details-box .label-text {
  color: var(--color-dark-grey);
}
.details-section .details-box .value-text {
  color: var(--color-maersk-darkblue);
  font-weight: bold;
}

table {
  font-size: var(--font-size-md) !important;
}
table .table-header-cell {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Global.scss","webpack://./src/Styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,4BAAA;EACA,iBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,gBAAA;AADF;AAEE;EACE,qCAAA;AAAJ;AACI;EACE,oCAAA;EACA,gBAAA;AACN;AAEU;EACE,8BAAA;EACA,gBAAA;AAAZ;AAMM;EACE,gBAAA;AAJR;AAUU;EACE,8BAAA;AARZ;AAsCI;EACE,0DAAA;AApCN;AAqCM;EACE,YAAA;EACA,iBAAA;EACA,oCAAA;AAnCR;AAsCI;EACE,oBAAA;EACA,4CAAA;EACA,mBAAA;AApCN;;AAwCA;EACE,+BAAA;EACA,iBAAA;AArCF;;AAwCE;EACE,uBAAA;AArCJ;AAuCE;EACE,uBAAA;AArCJ;;AAwCA;ECvFE,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;ADmDF;;AAkCA;EClFE,wCAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;ADoDF;;AA6BA;EACE,uBAAA;AA1BF;AA4BI;EACE,uBAAA;AA1BN;AA2BM;EACE,gBAAA;AAzBR;AA2BM;EACE,YAAA;AAzBR;;AAgCE;EACE,qCAAA;EACA,kBAAA;EACA,8BAAA;EACA,8BAAA;EACA,gBAAA;AA7BJ;AA8BI;EACE,6BAAA;AA5BN;AA8BI;EACE,mCAAA;EACA,iBAAA;AA5BN;;AAiCA;EACE,yCAAA;AA9BF;AA+BE;EAEE,eAAA;AA9BJ","sourcesContent":["@use \"../Styles/mixins.scss\";\n.main-body {\n  margin-left: 5rem !important;\n  transition: 850ms;\n // background: var(--color-white);\n  margin-top: 3rem;\n  position: relative;\n  min-height: 92vh;\n  .table-section {\n    border: solid 1px var(--border-color);\n    .rdt_TableHeadRow{\n      background-color: rgb(244 252 255);\n      min-height: 45px;\n      .rdt_TableCol{\n        .rdt_TableCol_Sortable{\n          div{\n            font-size: var(--font-size-md);\n            font-weight: 600;\n          }\n        }\n      }\n    }\n    .rdt_TableBody{\n      .rdt_TableRow{\n        min-height: 42px;\n        .rdt_TableCell{\n          a{\n          //  color: #318ead;\n          //  font-weight: 600;\n          }\n          div{\n            font-size: var(--font-size-md);\n          }\n          .gOyXrv{\n          //  background-color: rgb(66 176 213);\n          }\n          .bpQwNh{\n          //  background-color: rgb(157 157 157);\n          }\n          .fpqvjT{\n          //  background-color: rgb(207 100 110);\n          }\n          .iJlaxZ{\n          //  background-color: rgb(12 140 0);\n          }\n        }\n      }\n    }\n  }\n  .tags {\n   // border-radius: 3px;\n  //  padding: 0px 5px;\n  //  line-height: 16px;\n    span {\n      // font-size: var(--font-size-sm);\n      // white-space: nowrap;\n      // font-weight: 600;\n      // color: var(--color-white);\n    }\n  }\n  .modal {\n    > div:nth-child(1) {\n      box-shadow: inset 0px 3px 0px 0px var(--color-maersk-blue);\n      > div:nth-child(2) {\n        height: 50px;\n        padding: 0px 24px;\n        background-color: rgb(244 252 255);\n      }\n    }\n    .modal-headerSection {\n      padding: 0px 0px 8px;\n      border-bottom: solid 1px var(--border-color);\n      margin-bottom: 10px;\n    }\n  }\n}\n.Stechactive {\n  margin-left: 16.5rem !important;\n  transition: 350ms;\n}\n.button{\n  .icon:hover{\n    background: transparent;\n  }\n  span:hover{\n    background: transparent;\n  }\n}\n.header-text {\n  @include mixins.header-font;\n}\n.sub-header-text{\n  @include mixins.sub-header-font;\n}\n.step-Indicator{\n  padding: 15px 5rem 10px;\n  .stepIndicator{\n    ol{\n      justify-content: center;\n      li{\n        max-width: 20rem;\n      }\n      li:last-child{\n        flex-grow: 0;\n      }\n    }\n  }\n}\n\n.details-section{\n  .details-box{\n    border: var(--border-color) solid 1px;\n    text-align: center;\n    font-size: var(--font-size-md);\n    background: var(--color-white);\n    font-weight: 500;\n    .label-text{\n      color: var(--color-dark-grey);\n    }\n    .value-text{\n      color: var(--color-maersk-darkblue);\n      font-weight: bold;\n    }\n  }\n}\n\ntable {\n  font-size: var(--font-size-md) !important;\n  .table-header-cell{\n   // background-color: rgb(244 252 255);\n    cursor: pointer;\n  }\n}","@mixin header-font {\n  font-family: Maersk Headline, sans-serif;\n  font-size: 36px;\n  font-weight: 300;\n  line-height: 40px;\n  letter-spacing: 0em;\n  text-align: left;\n}\n@mixin sub-header-font {\n  font-family: Maersk Headline, sans-serif;\n  font-size: var(--font-size-lg);\n  font-weight: 700;\n  line-height: 24px;\n  text-align: left;\n}\n@mixin modal-header-font {\n  font-family: Maersk Headline, sans-serif;\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 24px;\n  letter-spacing: 0em;\n  text-align: left;\n  margin: 0px;\n  padding: 0px 0px;\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
